export default [
  {
    label: '10-K',
    labelToShow: 'Form 10-K',
    value: [
      { value: '10-K' },
      { value: '10-K/A' },
      { value: '10-K405' },
      { value: '10-K405/A' },
      { value: '10-KT' },
      { value: '10-KT/A' },
    ],
    documentTypeGroup: '10-K',
    documentTypeFillingGraph: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
    color: 'rgb(244,91,91)',
    index: 'fillings_sec_10K*',
  },
  {
    label: '10-Q',
    labelToShow: 'Form 10-Q',
    value: [{ value: '10-Q' }, { value: '10QSB' }, { value: '10-QT/A' }, { value: '10-QT' }, { value: '10-Q/A' }],
    documentTypeGroup: '10-Q',
    documentTypeFillingGraph: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
    color: 'rgb(247,163,92)',
    index: 'fillings_sec_10Q*',
  },
  {
    label: '20-F',
    labelToShow: 'Form 20-F',
    value: [{ value: '20-F' }, { value: '20-F/A' }],
    documentTypeGroup: '20-F',
    documentTypeFillingGraph: ['20-F', '20-F/A'],
    color: 'rgb(200,91,144)',
    index: 'fillings_sec_20f*',
  },
  {
    label: '40-F',
    labelToShow: 'Form 40-F',
    value: [{ value: '40-F' }],
    documentTypeGroup: '40-F',
    documentTypeFillingGraph: ['40-F'],
    color: 'rgb(80,91,144)',
    index: 'fillings_sec_20f*',
  },
  {
    label: '6-K',
    labelToShow: 'Form 6-K',
    value: [{ value: '6-k' }, { value: '6-K/A' }],
    documentTypeGroup: '6-K',
    documentTypeFillingGraph: ['6-K', '6-K/A'],
    color: 'rgb(210,91,148)',
    index: 'fillings_sec_6k*',
  },
  {
    label: '8-K',
    labelToShow: 'Form 8-K',
    value: [
      { value: '8-K15D5' },
      { value: '8-K12G3/A' },
      { value: '8-K12G3' },
      { value: '8-K12B/A' },
      { value: '8-K12B' },
      { value: '8-K/A' },
      { value: '8-K' },
    ],
    documentTypeGroup: '8-K',
    documentTypeFillingGraph: ['8-K15D5', '8-K12G3/A', '8-K12G3', '8-K12B/A', '8-K12B', '8-K/A', '8-K'],
    color: 'rgb(43,144,144)',
    index: 'fillings_sec_8k*',
  },
  {
    label: 'AR',
    labelToShow: 'Annual Report',
    value: [{ value: 'ARS/A' }, { value: 'ARS' }, { value: 'AR' }],
    documentTypeGroup: 'AR',
    documentTypeFillingGraph: ['ARS/A', 'ARS', 'AR', 'Annual Report'],
    color: 'rgb(00,91,91)',
    index: 'fillings_global_ar*',
  },
  {
    label: 'QR',
    labelToShow: 'Quarterly Report',
    value: [{ value: 'QR' }, { value: 'QR/A' }],
    documentTypeGroup: 'QR',
    documentTypeFillingGraph: ['QR', 'QR/A'],
    color: 'rgb(140,91,91)',
    index: 'fillings_global_qr*',
  },
  {
    label: 'SR',
    labelToShow: 'Semi-Annual Report',
    value: [{ value: 'SR' }],
    documentTypeGroup: 'SR',
    documentTypeFillingGraph: ['SR'],
    color: 'rgb(110,91,91)',
    index: 'fillings_global_sr*',
  },
  {
    label: 'ESG',
    labelToShow: 'ESG',
    value: [
      { value: 'TCFD Report' },
      { value: 'Sustainability Report' },
      { value: 'Environmental Report' },
      { value: 'Corporate Governance Report' },
      { value: 'Corporate Social Responsibility Report' },
    ],
    documentTypeGroup: 'ESG',
    documentTypeFillingGraph: [
      'Sustainability Report',
      'Corporate Social Responsibility Report',
      'Corporate Governance Report',
      'Environmental Report',
      'TCFD Report',
    ],
    color: 'rgb(139,92,246)',
    index: 'fillings_global_esg*',
  },
  {
    label: 'EC-FMP',
    labelToShow: 'Earnings Call',
    value: [{ value: 'FMP-Transcript' }],
    documentTypeGroup: 'EC-FMP',
    documentTypeFillingGraph: ['EC-FMP', 'FMP-Transcript', 'Earnings Call'],
    color: 'rgb(244,91,91)',
    index: 'fillings_sec_ecfmp*',
  },
  {
    label: 'FIN-SUPP',
    labelToShow: 'Financial Supplement',
    value: [{ value: 'FIN-SUPP' }],
    documentTypeGroup: 'FIN-SUPP',
    documentTypeFillingGraph: ['FIN SUPP', 'FS'],
    color: 'rgb(50,91,91)',
    index: 'fillings_global_finsupp*',
  },
  {
    label: 'OTH-FIN',
    labelToShow: 'Other Financials',
    value: [{ value: 'Other Financials' }],
    documentTypeGroup: 'OTH-FIN',
    documentTypeFillingGraph: ['OTH FIN', 'Other Financials', 'OF'],
    color: 'rgb(248,91,91)',
    index: 'fillings_global_othfin*',
  },
];
